module.exports = __webpack_public_path__ + "static/img/bottombg.9dd548f0.png";